import {
  LOAD_MATERIAL_QUOTA,
  EXPORT_MATERIAL_QUOTA,
  LOAD_MATERIAL_QUOTA_DETAIL,
  MATERIAL_QUOTA_MANAGEMENT,
  MATERIAL_QUOTA_LOCATION,
  MATERIAL_QUOTA_RAW_MATERIAL,
  REMOVE_LISTS,
} from './actions'

const initialState = {
  // *load ข้อมูลต้นแหล่ง
  source_list: [],
  check_source_list: false,

  // *load ข้อมูลวัตถุดิบ
  material_list: [],
  check_material_list: false,

  lists: [],
  total: 1,
  loading: false,
  draw: -1,
  check: true,
  // *detail
  lists_detail: [],
  check_detail: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case MATERIAL_QUOTA_LOCATION.REQUEST:
      return {
        ...state,
        source_list: [],
        check_source_list: true,
      }
    case MATERIAL_QUOTA_LOCATION.SUCCESS:
      return {
        ...state,
        source_list: action.payload.lists || [],
        check_source_list: false,
      }

    case MATERIAL_QUOTA_RAW_MATERIAL.REQUEST:
      return {
        ...state,
        material_list: [],
        check_material_list: true,
      }
    case MATERIAL_QUOTA_RAW_MATERIAL.SUCCESS:
      return {
        ...state,
        material_list: action.payload.lists || [],
        check_material_list: false,
      }

    case LOAD_MATERIAL_QUOTA.REQUEST:
      const { loading } = action.payload.data
      return {
        ...state,
        loading: loading,
      }

    case LOAD_MATERIAL_QUOTA.SUCCESS:
      const { page } = action.payload
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * 10
      }
      return {
        ...state,
        lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case EXPORT_MATERIAL_QUOTA.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case EXPORT_MATERIAL_QUOTA.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case LOAD_MATERIAL_QUOTA_DETAIL.REQUEST:
      return {
        ...state,
        lists_detail: null,
        check_detail: true,
      }

    case LOAD_MATERIAL_QUOTA_DETAIL.SUCCESS:
      return {
        ...state,
        lists_detail: action.payload.lists,
        check_detail: false,
      }

    default:
      return state
  }
}
